import {useMemo, useState} from 'react'

import {breakpoints} from 'styles/theme'
import {getFeatureCountryConfiguration} from '~/country-configuration/configuration'
import {Feature} from '~/country-configuration/types'
import {useFlags} from '~/flags'
import {ChoosePlanContainer} from '~/paywall/manage-plan/choose-plan-container'
import {getCountry, useUser} from '~/shell/user'
import * as tracking from '~/tracking'
import {useMediaQuery} from '~/web-platform/use-media-query'

import CashbackPromoCard from './cashback-promo-card/cashback-promo-card'
import PromoCard from './promo-card'
import {getMessage} from './promo-messages'

const PromoCardContainer = () => {
    const user = useUser()
    const country = getCountry(user)
    const message = useMemo(getMessage, [])
    const [isModalOpen, setIsModalOpen] = useState(false)
    const {growthGuide, cashbackPromoGuide} = useFlags()
    const {isCashBackCountry} = getFeatureCountryConfiguration(Feature.Paywall, country)

    const isDesktop = useMediaQuery(`(min-width: ${breakpoints.tabletMedUp})`)

    const shouldShowCashbackPromoCard = isCashBackCountry && cashbackPromoGuide && isDesktop

    const clickWithTracking = () => {
        if (!growthGuide) {
            tracking.promoCardActioned({
                action: 'viewed',
                message,
                placement: 'sidebar',
            })

            setIsModalOpen(true)
        }
    }
    const dismissModalWithTracking = (didCompleteAction?: boolean) => {
        tracking.promoCardActioned({
            action: didCompleteAction ? 'completed' : 'abandoned',
            message,
            placement: 'sidebar',
        })
        setIsModalOpen(false)
    }

    const clickCashbackPromoCardTracking = (text: string) => {
        tracking.promoCardActioned({
            action: 'viewed',
            message: text,
            placement: 'sidebar-cashback',
        })
    }

    return (
        <>
            {shouldShowCashbackPromoCard ? (
                <CashbackPromoCard onCardClicked={clickCashbackPromoCardTracking} />
            ) : (
                <PromoCard onCardClicked={clickWithTracking}>{message}</PromoCard>
            )}

            {!growthGuide && (
                <ChoosePlanContainer
                    isOpen={isModalOpen}
                    onDismiss={dismissModalWithTracking}
                    trackingOrigin="promo-card"
                />
            )}
        </>
    )
}

export default PromoCardContainer
